import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { ILoan } from '@internal-models/loan.model';
import { IDataQuery, ITableData } from '@beego/ngx-table';
import { IDevice } from '@internal-models/device.model';
import { encodeQueryUrl } from '@shared-libs/helpers';

@Injectable({
	providedIn: 'root',
})
export class LoanProvider extends Provider<ILoan> {
	protected readonly url: string = '/loans';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public async getAll(query: IDataQuery): Promise<ITableData<ILoan>> {
		return this.process(
			this.api.get(`${this.url}?query=${encodeQueryUrl(query)}`),
			!query.offset
		) as Promise<ITableData>;
	}

	public getAllOfClient(clientId: string): Promise<Array<ILoan>> {
		return this.process(this.api.get(`${this.url}/client/${clientId}`)) as Promise<Array<ILoan>>;
	}

	public getOne(loanId: string): Promise<ILoan> {
		return this.process(this.api.get(`${this.url}/${loanId}`)) as Promise<ILoan>;
	}

	public searchOnClient(name: string): Promise<Array<ILoan>> {
		return this.process(
			this.api.post(`${this.url}/search`, { client: name, partner: name }),
			false
		) as unknown as Promise<Array<ILoan>>;
	}

	public create(loan: ILoan): Promise<ILoan> {
		return this.process(this.api.post(`${this.url}`, loan)) as Promise<ILoan>;
	}

	public update(loanId: string, loan: ILoan): Promise<ILoan> {
		return this.process(this.api.put(`${this.url}/${loanId}`, loan)) as Promise<ILoan>;
	}

	public endLoan(loanId: string, Devices: Array<Pick<IDevice, 'id' | 'status' | 'note'>>): Promise<ILoan> {
		return this.process(this.api.put(`${this.url}/${loanId}/end`, { Devices })) as unknown as Promise<ILoan>;
	}
}
